import { CellProps, HeaderProps, Hooks } from 'react-table';

import { TableCheckboxInput } from 'coreOld/components';
import { CellText } from 'coreOld/elements';
import { SelectionOptions } from 'coreOld/enums';

import { Centered, Wrapper } from './checkboxesStyle';
import { DragHandle } from '../DragHandle';
import SelectAll from '../SelectAll';

let reverse = false;

export const renderCheckboxes = (
  hooks: Hooks<object>,
  hasRowSelection: boolean,
  selectMenuOptions: SelectionOptions[],
  hasLineNumbers: boolean,
  getRowLineNumber: (row: any) => number | string,
  hasRowReordering: boolean,
  checkboxFooter?: JSX.Element,
  isRowDeleted?: (item: any) => boolean
) => {
  if (!hasRowSelection) {
    return;
  }

  return hooks.visibleColumns.push((columns) => [
    {
      id: 'selection',
      minWidth: 30,
      width: 30,
      Header: ({
        getToggleAllRowsSelectedProps,
        toggleAllRowsSelected,
        isAllRowsSelected,
      }: HeaderProps<object>) => (
        <Centered>
          <SelectAll
            getToggleAllRowsSelectedProps={getToggleAllRowsSelectedProps}
            toggleAllRowsSelected={toggleAllRowsSelected}
            isAllRowsSelected={isAllRowsSelected}
            selectMenuOptions={selectMenuOptions}
          />
        </Centered>
      ),
      Footer: () => checkboxFooter,
      Cell: ({
        row,
        toggleRowSelected,
        selectedFlatRows,
        attributes,
        listeners,
        isGrabbing,
      }: CellProps<object, any>) => {
        const isDeleted = isRowDeleted && isRowDeleted(row.original);

        const ids = selectedFlatRows.map((item) => item.index);

        const min = Math.min(...ids) === Infinity ? 0 : Math.min(...ids);
        const max = Math.max(...ids) === Infinity ? 0 : Math.max(...ids);

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          event.preventDefault();

          window.getSelection()?.removeAllRanges();

          toggleRowSelected(row.id, Boolean(event.target.checked));

          if ((event.nativeEvent as PointerEvent)?.shiftKey) {
            const current = parseInt(row.id);

            if (min < current && max < current) {
              for (let i = min; i < current; i++) {
                toggleRowSelected(i.toString(), true);
              }

              reverse = false;
            }

            if (current < min && current < max) {
              for (let i = current; i < min; i++) {
                toggleRowSelected(i.toString(), true);
              }

              reverse = true;
            }

            if (current <= max && current >= min && min !== max) {
              if (!reverse) {
                for (let i = current; i <= max; i++) {
                  toggleRowSelected(i.toString(), false);
                }

                return;
              }

              for (let i = min; i <= current; i++) {
                toggleRowSelected(i.toString(), false);
              }
            }
          }
        };

        const lineNumber = getRowLineNumber(row);

        return (
          <Centered>
            <Wrapper>
              {!isDeleted && hasLineNumbers && lineNumber && (
                <CellText mainText={lineNumber} marginBottom={10} />
              )}

              {hasRowReordering && (
                <DragHandle attributes={attributes} listeners={listeners} isGrabbing={isGrabbing} />
              )}
            </Wrapper>

            <TableCheckboxInput {...row.getToggleRowSelectedProps()} onChange={handleChange} />
          </Centered>
        );
      },
    },
    ...columns,
  ]);
};
